module.exports = __webpack_public_path__ + "static/media/sygnet.9df8e001.svg";